import BasicLayout from '../../common/layouts/basicLayout';
import PivotTableChartIcon from '@mui/icons-material/PivotTableChart';
import CardsGrid, { CardsGridItem } from '../../common/components/cardsGrid/cardsGrid';
import ExtensionIcon from '@mui/icons-material/Extension';
import RttIcon from '@mui/icons-material/Rtt';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PreviewIcon from '@mui/icons-material/Preview';
import EjectIcon from '@mui/icons-material/Eject';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import Web from '@mui/icons-material/Web';
import ReceiptIcon from '@mui/icons-material/Receipt';

const gridItems: CardsGridItem[] = [
  {
    title: 'Planilhas',
    icon: PivotTableChartIcon,
    path: '/integracao/planilhas',
    subItems: true,
    requiredRoles: ['planilhas-visualizar'],
  },
  {
    title: 'TOTVS / Easy',
    icon: RttIcon,
    path: '/integracao/totvs-easy',
    subItems: true,
    requiredRoles: ['totvs-visualizar'],
  },
  {
    title: 'Croda',
    icon: AssessmentIcon,
    path: '/integracao/croda',
    subItems: true,
    requiredRoles: ['croda-visualizar'],
  },
  {
    title: 'OCR',
    icon: PreviewIcon,
    path: '/integracao/ocr',
  },
  {
    title: 'OCR Exportar Planilha',
    icon: PreviewIcon,
    path: '/integracao/ocr-export',
  },
  {
    title: 'Triangulus',
    icon: EjectIcon,
    path: '/integracao/triangulus',
    subItems: true,
    requiredRoles: ['triangulus-visualizar'],
  },
  {
    title: 'Crawlers',
    icon: SmartToyIcon,
    path: '/integracao/crawlers',
    subItems: true,
  },
  {
    title: 'Roche',
    icon: Web,
    path: '/integracao/roche',
    subItems: true,
    requiredRoles: ['roche-visualizar'],
  },
  {
    title: 'Thermo-Fisher',
    icon: Web,
    path: '/integracao/thermo-fisher',
    subItems: true,
    requiredRoles: ['thermo-fisher-visualizar'],
  },
  {
    title: 'Sap-Mtn',
    icon: AssessmentIcon,
    path: '/integracao/sapmtn',
    subItems: true,
    requiredRoles: ['sap-mtn-visualizar'],
  },
  {
    title: 'Dior',
    icon: ReceiptIcon,
    path: '/integracao/dior',
    requiredRoles: ['planilha-fatura-dior-visualizar'],
  },
  {
    title: 'E-mix',
    icon: ReceiptIcon,
    path: '/integracao/emix',
    requiredRoles: ['planilha-fatura-dior-visualizar'],
  },
  {
    title: 'TS-Tech',
    icon: ReceiptIcon,
    path: '/integracao/ts-tech',
    subItems: true,
    requiredRoles: ['ts-tech-visualizar'],
  },
  {
    title: 'Rolex',
    icon: ReceiptIcon,
    path: '/integracao/rolex',
    subItems: true,
    requiredRoles: ['rolex-visualizar'],
  },
    {
    title: 'Prada',
    icon: ReceiptIcon,
    path: '/integracao/prada',
    subItems: true,
    requiredRoles: ['prada-visualizar'],
  },
  {
    title: 'Apple',
    icon: AssessmentIcon,
    path: '/integracao/apple',
    subItems: true,
    requiredRoles: ['martins-log-visualizar'],
  },
  {
    title: 'CONTÁBIL - SISTEMA ÚNICO',
    icon: AssessmentIcon,
    path: '/integracao/contabil-sistema-unico',
    requiredRoles: ['contabil-sistema-unico-visualizar'],
  },
  {
    title: 'PROFORMA / PACKING LIST SAÍDA',
    icon: ReceiptIcon,
    path: '/integracao/proforma-packing-list-saida',
    requiredRoles: ['proforma-packing-list-saida-visualizar'],
  },
];

const IntegracaoPage = () => {
  return (
    <BasicLayout title={'Integração'} icon={<ExtensionIcon color={'secondary'} />}>
      <CardsGrid items={gridItems}></CardsGrid>
    </BasicLayout>
  );
};

export default IntegracaoPage;
